import {Injectable} from '@angular/core';
import {BaseService} from "../../BaseService";
import {Subject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class GrpcAuthorizationOPEService extends BaseService {

  readonly impersonationEnded$ = new Subject<void>();

  startImpersonation(jwt: string, preferences?: { language?: string; isDarkTheme?: boolean }) {
    sessionStorage.setItem('impersonationToken', jwt);
    if (preferences?.language !== undefined) {
      sessionStorage.setItem('language', preferences.language);
    }
    if (preferences?.isDarkTheme !== undefined) {
      sessionStorage.setItem('isDarkTheme', String(preferences.isDarkTheme));
    }
  }

  isImpersonating(): boolean {
    return !!sessionStorage.getItem('impersonationToken');
  }

  stopImpersonation() {
    sessionStorage.removeItem('impersonationToken');
    sessionStorage.removeItem('language');
    sessionStorage.removeItem('isDarkTheme');
  }

  cleanupServiceFields(): void {
    // doNothing
  }
}
